import { loadingAppsTable } from '@/containers/applications/table'
import { convocatoriasStateActions } from '@/state/actions'
import { ConvocatoriasState } from '@/state/convocatorias'
import { OfflineState } from '@/state/offline-management'
import { useComputed } from '@preact/signals-react'
import { Select } from 'antd'

export default function ConvocatoriaDetails() {
  const convocatoriasOptions = useComputed(() => {
    return ConvocatoriasState.convocatorias.value.map((item) => ({
      label: item.name,
      value: item.id,
    }))
  })

  return (
    <Select
      className='convocatoria-filter'
      allowClear
      showSearch
      placeholder='Seleccionar convocatoria'
      options={convocatoriasOptions.value}
      onChange={convocatoriasStateActions.setCurrentConvocatoria}
      filterOption={(input, option: any) =>
        option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      value={ConvocatoriasState.currentConvocatoria.value.id}
      disabled={OfflineState.isSynchronizing.value || loadingAppsTable.value}
    />
  )
}
